module.exports = __webpack_public_path__ + "static/media/carlysh_carlysh-R2-044-20A.37a33a45.jpg";